import { render, staticRenderFns } from "./ad-material.vue?vue&type=template&id=2ae2d59c&scoped=true"
import script from "./ad-material.vue?vue&type=script&lang=js"
export * from "./ad-material.vue?vue&type=script&lang=js"
import style0 from "./ad-material.vue?vue&type=style&index=0&id=2ae2d59c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae2d59c",
  null
  
)

export default component.exports